import { IconButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentProps, memo, type MouseEventHandler, use, useCallback } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { FilterRendererContext } from "../contexts/FilterRendererContext/context"
import type { AnyFilter } from "../filter"
import type { AnyFilterManager } from "../manager"

interface RemoveFilterButtonProps extends Omit<ComponentProps<typeof IconButton>, "children"> {
	filter: AnyFilter
	filterManager: AnyFilterManager
}

export const RemoveFilterButton = memo<RemoveFilterButtonProps>((props) => {
	const filterRendererContext = use(FilterRendererContext)
	const {
		filter,
		filterManager,
		size = filterRendererContext.size,
		variant = filterRendererContext.variant,
		onClick,
		...rest
	} = props

	const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
		(e) => {
			onClick?.(e)
			if (e.defaultPrevented) return
			filterManager.removeFilter(filter.id)
		},
		[filter.id, filterManager, onClick],
	)

	return (
		<IconButton onClick={handleClick} size={size} variant={variant} accentColor="base" {...rest}>
			<LuIcon icon={modelIconMapping.close} />
		</IconButton>
	)
})
RemoveFilterButton.displayName = "RemoveFilterButton"
